<app-modal [(visible)]="isCreateVisible" header="EDIT Field Tech Details" (visibleChange)="visibleChange($event)">

  <form [formGroup]="formGroup">

    <div class="p-fluid">
      <div class="p-col-12 p-md-12 p-lg-12">
        <form-factory [formGroup]="formGroup" [model]="groupName"></form-factory>
      </div>

      <div class="p-col-12 p-md-12 p-lg-12">
        <form-factory [formGroup]="formGroup" [model]="email"></form-factory>
      </div>

      <div class="p-col-12 p-md-12 p-lg-12">
        <form-factory [formGroup]="formGroup" [model]="phone"></form-factory>
      </div>

      <div class="p-col-12 p-md-12 p-lg-12">
        <form-factory [formGroup]="formGroup" [model]="fax"></form-factory>
      </div>

      <div class="p-col-12 p-md-12 p-lg-12">
        <form-factory [formGroup]="formGroup" [model]="contactName"></form-factory>
      </div>

    </div>

  </form>

  <footer>
    <app-button class="header-button" text="APPLY EDITS" (onClick)="onUpdate()"></app-button>
  </footer>

</app-modal>

